import { createActionGroup, props } from "@ngrx/store";

import { ActionSource } from "./action-sources";
import { UnsavedChange } from "./unsaved-changes.reducer";

export const UnsavedChangesActions = createActionGroup({
  source: ActionSource.UNSAVED_CHANGES,
  events: {
    'Replay Triggered': props<{ changes: UnsavedChange[] }>(),
  },
});
